import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm4 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-8-1a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
      clipRule: "evenodd"
    }
  )
);
var SvgKeyboardShortcutsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var KeyboardShortcutsFilled_default = SvgKeyboardShortcutsFilled;

export { KeyboardShortcutsFilled_default as default };
